<template>
  <div>
      <breadcrumb :breadcrumb="breadcrumb" />
      <div class="search-line">
        <div style="display:flex;justify-content:flex-start;align-items:center;">
          <button-add :pathName="addOneAccountName" v-if="permissionCodes.indexOf('004030001') !== -1"></button-add>
        <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage"
          v-if="permissionCodes.indexOf('004030003') !== -1"
          value="导入"/>
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          download="download.xls"
          v-if="permissionCodes.indexOf('004030004') !== -1"
          value="导出"/>
        </div>
        <input-search placeholder="车位号/车牌号/租赁人" @search="searchKey"/>
      </div>
      <div class="search-line">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">到期时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                        :picker-options="pickerOptions" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        </div>
        <input-select selectTitle="租赁周期" :selectKey="'paymentCycle'" :selectData="fixTypeList" @search="search"/>
        <input-select selectTitle="租赁状态" :selectKey="'status'" :selectData="bindTypeList" @search="search"/>
      </div>
      <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :pageNum="pageNum" :pageSize="pageSize" :operationArr="operationArr" @changePagination="changePagination" :total="total" @deleteLine="deleteLine" @cancellation="cancellation" @lookOver2="lookOver2"/>
      <el-dialog
        :visible.sync="dialogVisible"
        width="40%">
        <img :src="lookOverImgUrl" alt="" style="width: 90%;margin: 0 auto;">
      </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-month-bill",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位租赁"
        }
      ],
      tableHead: [
        {
          prop: "parkingLotArea",
          label: "车位区域"
        },
        {
          prop: "parkLotNumber",
          label: "车位号"
        },
        {
          prop: "personName",
          label: "租赁人"
        },
        {
          prop: "personPhone",
          label: "手机号"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        },
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "leaseStartTime",
          label: "租赁开始时间"
        },
        {
          prop: "leaseStopTime",
          label: "租赁截止时间"
        },
        {
          prop: "leaseValidityTime",
          label: "到期天数"
        },
        {
          prop: "paymentCycleText",
          label: "缴费周期"
        },
        {
          prop: "statusText",
          label: "租赁状态"
        },
        {
          prop: "annexUrl",
          isPreviewPic2: true,
          label: "附件"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      timevalue: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [],
      selectionArr: [],
      exportUrl: "",
      requestData: {
        searchKey: "",
        billTypeText: "",
        billType: "",
        paymentMethod: "",
        paymentCycle: "",
        status: "",
        startTime: "",
        endTime: ""
      },
      addOneAccountName: "parking-rent-add",
      uploadUrl: "",
      operationArr: ["cancellation"],
      fixTypeList: [],
      bindTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "申请审批中"
        },
        {
          key: "1",
          label: "申请生效"
        },
        {
          key: "2",
          label: "申请驳回"
        },
        {
          key: "3",
          label: "退还审批中"
        },
        {
          key: "4",
          label: "已退还"
        },
        {
          key: "5",
          label: "退还已驳回"
        },
        {
          key: "6",
          label: "已到期"
        },
        {
          key: "7",
          label: "已作废"
        },
        {
          key: "8",
          label: "续租申请中"
        },
        {
          key: "9",
          label: "续租已驳回"
        }
      ],
      lookOverImgUrl: "",
      dialogVisible: false
    };
  },
  created() {
    this.getPage();
    this.getList();
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importParkingRent;
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingRent}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&paymentCycle=${this.requestData.paymentCycle}&status=${
        this.requestData.status
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }`;
    },
    getList() {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          configType: 4
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.label = "月缴";
              } else if (v.paymentCycle === "2") {
                v.label = "季缴";
              } else if (v.paymentCycle === "3") {
                v.label = "半年缴";
              } else if (v.paymentCycle === "4") {
                v.label = "年缴";
              }
              v.key = v.paymentCycle;
            });
            data.unshift({
              key: "",
              label: "全部"
            });
            this.fixTypeList = data;
            console.log(this.fixTypeList);
          }
        })
        .catch(errorHandler("获取配置数据失败"));
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      console.log(this.requestData);
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getParkingLotLeasePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.leaseStartTime) {
              v.leaseStartTime = v.leaseStartTime.substring(0, 10);
            }
            if (v.leaseStopTime) {
              v.leaseStopTime = v.leaseStopTime.substring(0, 10);
            }
            if (v.status == "0") {
              v.statusText = "申请审批中";
            } else if (v.status == "1") {
              v.statusText = "申请生效";
            } else if (v.status == "2") {
              v.statusText = "申请驳回";
            } else if (v.status == "3") {
              v.statusText = "退还审批中";
            } else if (v.status == "4") {
              v.statusText = "已退还";
            } else if (v.status == "5") {
              v.statusText = "退还已驳回";
            } else if (v.status == "6") {
              v.statusText = "已到期";
            } else if (v.status == "7") {
              v.statusText = "已作废";
            } else if (v.status == "8") {
              v.statusText = "续租申请中";
            } else if (v.status == "9") {
              v.statusText = "续租已驳回";
            }
            if (v.paymentCycle == "1") {
              v.paymentCycleText = "月缴";
            } else if (v.paymentCycle == "2") {
              v.paymentCycleText = "季缴";
            } else if (v.paymentCycle == "3") {
              v.paymentCycleText = "半年缴";
            } else {
              v.paymentCycleText = "年缴";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取分页失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    deleteLine() {},
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    cancellation(code) {
      this.$confirm("是否确认作废该条租赁车位？", "提示")
        .then(() => {
          this.$axios.post(api.cancelParkingRent, [code.code]).then(res => {
            nSuccess("作废成功");
            this.getPage();
          });
        })
        .catch(() => {
          errorHandler("作废失败");
        });
    },
    lookOver2(img) {
      this.lookOverImgUrl = img;
      this.dialogVisible = true;
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingRent/ParkingRent.vue